import { Injectable } from '@angular/core';
import { EntityStatus } from '@core';
import { IncidentSeverity } from '@models';
import { BehaviorSubject, Observable } from 'rxjs';

type MapFilter = string[];

@Injectable({
  providedIn: 'root',
})
export class MapFilterService {
  mapFilter$: Observable<MapFilter>;

  mapFilterOptions = [
    {
      checked: false,
      title: 'Building with new critical incident',
      value: IncidentSeverity.CRITICAL,
    },
    {
      checked: false,
      title: 'Building with major incident',
      value: IncidentSeverity.MAJOR,
    },
    {
      checked: false,
      title: 'Building with minor incident',
      value: IncidentSeverity.MINOR,
    },
    {
      checked: false,
      title: 'Building without incident',
      value: 'good',
    },
    {
      checked: false,
      title: 'Building on Pause',
      value: EntityStatus.Paused,
    },
  ];

  get mapFilter() {
    return this._mapFilter.value;
  }

  set mapFilter(filter: string[]) {
    this.mapFilterOptions = this.mapFilterOptions.map(option => {
      option.checked = filter.includes(option.value);

      return option;
    });
    this.updateMapFilterSubject();
  }

  private _mapFilter = new BehaviorSubject<MapFilter>([]);

  constructor() {
    this.mapFilter$ = this._mapFilter.asObservable();
  }

  updateMapFilterOption(filter: { checked: boolean; value: string; }) {
    this.mapFilterOptions = this.mapFilterOptions.map(option => {
      if (option.value === filter.value) {
        option.checked = filter.checked;
      }

      return option;
    });
    this.updateMapFilterSubject();
  }

  updateMapFilterSubject() {
    this._mapFilter.next(this.mapFilterOptions.filter(({ checked }) => checked).map(({ value }) => value));
  }
}
